import React from 'react';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import DeleteModalIcon from '../../../../../../assets/delete-modal-icon.svg';

const ConfirmDeleteModal = ({ setOpen, handleDelete }) => {
  return (
    <Box
      backdropFilter={'blur(10px)'}
      background={'rgba(255, 255, 255, 0.719)'}
      position={'absolute'}
      top="0"
      right="0"
      bottom="0"
      zIndex="1000"
      w={'100%'}
      h={'100%'}
      minW={'300px'}
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        w={{ base: '100%', md: 'fit-content' }}
        transform="translate(-50%, -50%)"
        display={'flex'}
        flexDir={'column'}
        alignItems={'center'}
        p={4}
        gap={'24px'}
        textAlign={'center'}
      >
        <Text fontSize={'20px'} fontWeight={800}>
          Delete comment?
        </Text>
        <img className="w-[52px] h-[52px]" src={DeleteModalIcon} alt="" />
        <Text fontSize={'18px'} fontWeight={600}>
          This action will permanently delete your comment
        </Text>
        <HStack w={'100%'}>
          <Button
            bg={'white'}
            border={'2px solid'}
            borderColor={'growth-green'}
            rounded={'8px'}
            w={'100%'}
            onClick={() => setOpen(false)}
            h={'42px'}
            color={'growth-green'}
            fontWeight={900}
            fontSize={'md'}
            _hover={{ opacity: '0.9' }}
          >
            Cancel
          </Button>
          <Button
            bg={'error-red'}
            color={'white'}
            border={'1px solid'}
            borderColor={'error-red'}
            rounded={'8px'}
            w={'100%'}
            h={'42px'}
            onClick={handleDelete}
            fontWeight={900}
            fontSize={'md'}
            _hover={{ opacity: '0.7' }}
          >
            Delete
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};

export default ConfirmDeleteModal;
